/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const PolicyPlanOrderRequest = zod
	.object({
		policy_plan_ids: zod.array(zod.uuid()).describe('Ordered list of policy plan IDs')
	})
	.describe('Request body for reordering policy plan components');

export type PolicyPlanOrderRequest = zod.input<typeof PolicyPlanOrderRequest>;
export type PolicyPlanOrderRequestOutput = zod.output<typeof PolicyPlanOrderRequest>;
